import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, input, inject, model, effect, forwardRef } from '@angular/core';
import { Feature, PluggableMap } from 'ol';
import { Control } from 'ol/control';
import { Draw, Interaction, Snap } from 'ol/interaction';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Subscription } from 'rxjs';
import { PropertyService } from 'src/app/services/property.service';
import { DrawType } from 'src/app/_helpers/enums';
import { ESKTOOL_TOKEN, EskTool } from 'src/app/shared/features/esk-tool/esk-tool-interface';
import { EskToolDirective } from 'src/app/shared/features/esk-tool/EskTool.directive';

import * as conditions  from 'ol/events/condition'
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-digitize-paddock',
    templateUrl: './digitize-paddock.component.html',
    styleUrls: ['./digitize-paddock.component.css'],
    imports:[CommonModule],
    providers: [
        { provide: ESKTOOL_TOKEN, useExisting: forwardRef(() => DigitizePaddockComponent) }
    ],
    hostDirectives:[EskToolDirective]
})
export class DigitizePaddockComponent implements OnInit,AfterViewInit, OnDestroy, EskTool {
  private propertyService = inject(PropertyService);
  private elRef = inject(ElementRef);

  readonly map = input<PluggableMap>(undefined);
  readonly snapLayers = input<Array<VectorLayer<any>>>(undefined);

  @Output() paddockDigitized = new EventEmitter<Feature<any>>();

  active = model<boolean>();
  disabled: boolean = false;
  interaction: Draw;
  snapInteractions: Array<Snap> = [];
  vectorSource: VectorSource<any>;
  control: Control;


  propertySub$: Subscription = new Subscription();

  activeEffect = effect(() => {
    const active = this.active();
    if (active) {
      this.draw();
    } else {
      this.deSelect();
    }
  });

  ngOnInit(): void {
    this.propertySub$ = this.propertyService.activeProperty.subscribe(property => {
      this.disabled = property == null ? true : false;
    });

    this.vectorSource = new VectorSource();
  }

  ngAfterViewInit(): void {
    this.control = new Control({target: this.elRef.nativeElement.parentNode, element: this.elRef.nativeElement});
    this.map().addControl(this.control);
  }

  ngOnDestroy(): void {
    if(this.control == null)
    return;

    this.propertySub$.unsubscribe();

    this.map().removeControl(this.control);
    this.deSelect();
  }


  toggleDigitizePaddock(){
    this.active.set(!this.active());
  }


  private draw() {

    this.interaction = new Draw({
      source: this.vectorSource,
      type: DrawType.Polygon,
      snapTolerance: 5,
      clickTolerance:0
    });

      this.snapLayers().forEach(lyr => {
        let snap = new Snap(
          {
            source: lyr.getSource()
          }
        )

        this.snapInteractions.push(
          snap
          )
      });

    this.map().addInteraction(this.interaction);

    this.snapInteractions.forEach(snap => {
      this.map().addInteraction(snap);
    })

    this.interaction.on('drawend', (event) => {
      var feature = event.feature as Feature<any>;

      this.paddockDigitized.emit(feature);
    });

  }

  deSelect() {
    this.map().removeInteraction(this.interaction);
    this.snapInteractions.forEach(snap => {
      this.map().removeInteraction(snap);
    });

    this.snapInteractions = [];
  }

}
